var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.title}},[_c('security-deposits-table',{attrs:{"items":_vm.items,"loading":_vm.loading,"sort-field":_vm.sortField,"sort-order":_vm.sortOrder,"list-type":_vm.listType},on:{"updated":_vm.onItemsUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }